import React from "react";
import Link from "components/link";
import { PortableText } from "@portabletext/react";
import clsx from "clsx/lite";

// Marks
const Links = ({ children, value }) => <Link to={value.href} isTargetBlank={value.openInNewTab}>{children}</Link>;

const CenterText = ({ children }) => <div className="text-center">{children}</div>;

const TextStyle = ({ children, value }) => {
	const bgColor = value?.bgColor?.color?.hex;
	const flashingColor1 = value?.flashingColor1?.hex;
	const flashingColor2 = value?.flashingColor2?.hex;
	return (
		<span
			className={clsx(
				"text-center w-fit",
				value.flashing && "animated-flash",
				value?.fontFamily === "Prata" && "text-[85%]",
				bgColor && "block py-1 px-4 min-w-64"
			)}
			style={{
				fontFamily: value?.fontFamily,
				color: value?.highlight?.color?.hex,
				backgroundColor: bgColor,
				"--flashing-color-1": flashingColor1,
				"--flashing-color-2": flashingColor2,
			}}>
			{children}
		</span>
	);
};

const richTextComponents = {
	marks: {
		link: Links,
		center: CenterText,
		textStyle: TextStyle,
	},
};

const CustomRichText = ({ data }) => {
	if (!data?.length) return null;

	return (
		<div className="rich-text">
			<PortableText value={data} components={richTextComponents} />
		</div>
	);
};

export default CustomRichText;